import React from 'react'

import Box from '@/modules/components/Box'
import Column from '@/modules/components/Column'
import Container from '@/modules/components/Container'
import Flex from '@/modules/components/Flex'
import Row from '@/modules/components/Row'
import Typography from '@/modules/components/Typography'
import { LowerRegions } from '@/modules/configs/region'

import { Certificates } from './Certificates'
import { DesktopMenu } from './desktop'
import { Downloads } from './Downloads'
import { getRegionConfig } from './getRegionConfig'
import { LegalSection } from './Legal'
import MobileMenu from './mobile'
import { Social } from './Social'

const Footer = ({ region }: { region: LowerRegions }) => {
  const {
    desktopMenu,
    mobileMenu,
    disclaimers,
    legalLinks,
    menuWidth,
    isShowEALogo,
  } = getRegionConfig(region)

  return (
    <Box backgroundColor="#0B1426">
      <Container paddingTop={[15, 9, 15]} paddingBottom={[7, 5, 7]}>
        <Row>
          <Column width={[1, 1, 3 / 4]} mb={[10, 8, 0]}>
            <Box display={['none', 'block']}>
              <DesktopMenu menuData={desktopMenu} menuWidth={menuWidth} />
            </Box>
            <Box display={['block', 'none']}>
              <MobileMenu menuData={mobileMenu} />
            </Box>
          </Column>
          <Column width={[1, '40%', 1 / 4]} mt={[0, 3, 0]}>
            <Flex
              flexDirection={['row', 'column', 'column']}
              justifyContent={['space-between', 'space-between', 'flex-start']}
            >
              <Box display={['none', 'block']} mb={[0, 5, 5]}>
                <Downloads />
              </Box>
              <Social />
            </Flex>
          </Column>
          <Column
            ml={'auto'}
            width={[1, '239px']}
            order={[0, 0, 1]}
            display={['none', 'block', 'none']}
            justifyContent={['unset', 'unset', 'flex-end']}
          >
            <Certificates />
          </Column>
        </Row>
        <Box mt={[0, 0, 18]}>
          <Row alignItems="flex-end">
            <Column
              width={[1, 1, 5 / 8]}
              order={[1, 1, 0]}
              mt={[8, 8, 0]}
              px={['8px', '0px !important', '10px !important']}
            >
              {disclaimers.map((disclaimer, index) => (
                <Typography
                  key={index}
                  variant="p"
                  fontSize={11}
                  fontWeight={400}
                  lineHeight="135%"
                  color="#A0A9BE"
                  marginTop="16px"
                  dangerouslySetInnerHTML={{ __html: disclaimer }}
                />
              ))}
            </Column>
            <Column
              ml={'auto'}
              width={[1, '239px']}
              order={[0, 0, 1]}
              display={['none', 'none', 'flex']}
              justifyContent={['unset', 'unset', 'flex-end']}
            >
              <Certificates />
            </Column>
          </Row>
        </Box>
        <Box my={2} height={1} bg="primaryPaleWhite" opacity={0.2} />
        <LegalSection links={legalLinks} isShowEALogo={isShowEALogo} />
      </Container>
    </Box>
  )
}

export const GlobalFooter = () => <Footer region="global" />
export const USFooter = () => <Footer region="us" />
export const EEAFooter = () => <Footer region="eea" />
export const SGFooter = () => <Footer region="sg" />
export const AUFooter = () => <Footer region="au" />
export const BRFooter = () => <Footer region="br" />
export const TRFooter = () => <Footer region="tr" />
export const FRFooter = () => <Footer region="fr" />
